import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CorporateFormValues } from '../../../new-application/types';
import { applicationsApi } from '../../../new-application/store/services';

export interface CreateCorporateCustomertState {
  requestInProgress?: boolean;
  formValues: CorporateFormValues;
  panelIsOpen: boolean;
  submitSuccess?: boolean;
}

export const defaultFormValues = {
  countryOfIncorporationId: '',
  companyName: '',
};

const initialState: CreateCorporateCustomertState = {
  requestInProgress: false,
  panelIsOpen: false,
  formValues: defaultFormValues,
  submitSuccess: false,
};

export const corporateCustomerCreateSlice = createSlice({
  name: 'corporateCustomerCreate',
  initialState,
  reducers: {
    changePanelState: (state, action: PayloadAction<boolean>) => {
      state.panelIsOpen = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      applicationsApi.endpoints.createCorporateApplication.matchFulfilled,
      (state) => {
        state.submitSuccess = true;
      },
    );
  },
});

export const { changePanelState } = corporateCustomerCreateSlice.actions;

export default corporateCustomerCreateSlice.reducer;
